<template>
  <van-popup v-model="show" get-container="body" position="bottom" style="height: 100%;">
    <van-nav-bar :title="title" fixed left-arrow @click-left="show=false" />
    <div class="pdf-container">
      <vue-pdf-embed :source="url" />
    </div>
  </van-popup>
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
export default {
  name: 'PdfPreviewPopup',
  components: {
    VuePdfEmbed
  },
  data() {
    return {
      show: false,
      url: null,
      title: null
    }
  },
  methods: {
    open(url, title) {
      this.url = url
      this.title = title
      this.show = true
    }
  }
}
</script>

<style lang="less" scoped>
</style>
